import React, { Fragment } from 'react';

import useCsvData from '~/kits/general/scripts/hooks/useCsvData';
import MiniChart from '../MiniChart';
import Grid from '../Grid';
import config from './config';
import { is768Query } from '~/core/scripts/mediaquery-helper';

const isSmallScreen = !is768Query();
const parseRow = r => {
  const splittedDate = r.Datum.split('.');

  return {
    date: new Date(`20${splittedDate[2]}`, +splittedDate[1] - 1, splittedDate[0]),
    state: r.Bundesland,
    value: +r.AfD
  };
};

const parseRowArea = r => {
  const splittedDate = r.date.split('-');

  return {
    date: new Date(splittedDate[0], +splittedDate[1] - 1, splittedDate[2]),
    value: +r.value
  };
};


export default () => {
  const data = useCsvData('AfD_umfragen_seit2013_laender.csv', parseRow);
  const areaData = useCsvData('loess_afd.csv', parseRowArea);

  if (!data) {
    return null;
  }

  const groupedDataLookup = data.reduce((res, item) => {
    res[item.state] = res[item.state] ? res[item.state] : [];
    res[item.state].push(item);

    return res;
  }, {});

  const gridConfig = config.map(c => ({
    ...c,
    props: {
      state: c.state,
      stateShort: c.stateShort,
      data: groupedDataLookup[c.state],
      aboveAvg: c.aboveAvg,
      areaData
    }
  }));

  const gridConfigAbove = gridConfig.filter(c => c.aboveAvg);
  const gridConfigBelow = gridConfig.filter(c => !c.aboveAvg);

  return (
    <div className="smallmultiples__list">
      {isSmallScreen ? (
        <Fragment>
          <div className="smallmultiples__legend">
            Bundesländer mit Umfragewerten mehrheitlich <strong>über</strong> dem Durchschnitt
          </div>
          <Grid
            Component={MiniChart}
            config={gridConfigAbove}
          />
          <div className="smallmultiples__legend">
            Bundesländer mit Umfragewerten mehrheitlich <strong>unter oder im</strong> dem Durchschnitt
          </div>
          <Grid
            Component={MiniChart}
            config={gridConfigBelow}
          />
        </Fragment>
      ) : (
      <Grid
        rows={6}
        columns={4}
        Component={MiniChart}
        config={gridConfig}
      />
      )}
      {!isSmallScreen && (
        <div className="smallmultiples__legend">
          Umfragewerte mehrheitlich <span className="below"><span className="minichart__avgicon"></span> im oder unter</span> und <span className="above"><span className="minichart__avgicon above"></span> über</span> dem Bundesdurchschnitt
        </div>
      )}
    </div>
  );
};
